import React from "react";
import Background from '../images/white-desk.jpg';
import "../styles/main.css"
import "../styles/contactus.css";
import ContactUsForm from "../components/ContactUsForm";

export default class ContactUs extends React.Component {

    render() {
        return (
            <div className="outer-container-contact">
                <div className="container-my-contact">
                    <img src={Background} className="responsive-contact"/>
                    <div className="content-contact">
                        <div className="heading-contact">
                            CONTACT US
                            <h1>-</h1>
                        </div>
                        <ContactUsForm/>
                    </div>
                </div>
            </div>
        )
    }
}